import * as React from 'react';
import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
//import Tooltip from '@mui/material/Tooltip';
//import Button from '@mui/material/Button';
//import IconButton from '@mui/material/IconButton';
//import Dialog from '@mui/material/Dialog';
//import Zoom from '@mui/material/Zoom';
//import ReplayIcon from '@mui/icons-material/Replay';
//import { InvoiceDocumentEditor } from '../InvoiceDocument/InvoiceDocumentEditor';
import { Constants } from '../Common/Constants';
import Link from '@mui/material/Link';
import { toast } from 'react-toastify';
import { httpGet, httpPost } from '../../HttpRequestHandling/httpRequestHandler';
import { formatNumber, splitByUppercase, stringIsNullOrEmpty, downloadInvoiceFile, getFileIcon, getDisplayName } from '../Common/Utilities';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import ServerExportWrapper from '../Common/DataGridServerExportWrapper';
//import { GridFilterInputSingleSelect } from '@mui/x-data-grid';
import { getFilter, setFilter } from '../Common/Utilities';
import { Check } from '@mui/icons-material';
import RemoveIcon from '@mui/icons-material/Remove';
import Dialog from '@mui/material/Dialog';
import { InvoiceDocumentEditor } from '../InvoiceDocument/InvoiceDocumentEditor';
import { CopyableCell } from '../Common/Components/CopyableCell';

import { Checkbox, CircularProgress, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, ListItemText } from "@mui/material";

//const Transition = React.forwardRef(function Transition(props, ref) {
//    return <Zoom in={true} ref={ref} {...props} />;
//});

const auditFilterFieldMap = {
    companyCode: 'company_code',
    companyName: 'company_name',
    invoiceDocumentId: 'invoice_document_id',
    invoiceNumber: 'invoice_number',
    invoiceDetailLine: 'invoice_detail_line',
    vendorCode: 'vendor_code',
    vendorName: 'vendor_name',
    invoiceStatus: 'invoice_status',
    invoiceDate: 'invoice_date',
    postedUserName: 'invoice_created_user',
    isAutoMatch: 'auto_match',
    discrepancyPeriod: 'invoice_discrepance_waiting_days',
    approvalLevel1Date: 'approval_level_1_date',
    approvalLevel1By: 'approval_level_1_by',
    approvalLevel1WaitingDays: 'approval_level_1_waiting_days',
    approvalLevel2Date: 'approval_level_2_date',
    approvalLevel2By: 'approval_level_2_by',
    approvalLevel2WaitingDays: 'approval_level_2_waiting_days',
    approvalLevel3Date: 'approval_level_3_date',
    approvalLevel3By: 'approval_level_3_by',
    approvalLevel3WaitingDays: 'approval_level_3_waiting_days',
    approvalLevel4Date: 'approval_level_4_date',
    approvalLevel4By: 'approval_level_4_by',
    approvalLevel4WaitingDays: 'approval_level_4_waiting_days',
    approvalLevel5Date: 'approval_level_5_date',
    approvalLevel5By: 'approval_level_5_by',
    approvalLevel5WaitingDays: 'approval_level_5_waiting_days',
    paymentDays: 'paid_days',
    paymentDate: 'document_date'
};

const mapAuditFilterField = (field) => auditFilterFieldMap[field] || splitByUppercase(field).join('_');

const normalizeAuditFilterValue = (field, value) => {
    if (value === undefined || value === null || value === '') return value;

    if (field === 'isAutoMatch') {
        if (value === 'Y' || value === '1' || value === 1 || value === true) return 1;
        if (value === 'N' || value === '0' || value === 0 || value === false) return 0;
    }

    return value;
};

const getAutoMatchFilterOperators = () => ([
    {
        label: 'is',
        value: 'is',
        getApplyFilterFn: (filterItem) => {
            if (!filterItem.value) {
                return null;
            }
            return (params) => String(params.value ?? '') === String(normalizeAuditFilterValue('isAutoMatch', filterItem.value));
        },
        InputComponent: ({ item, applyValue }) => {
            React.useEffect(() => {
                if (!item.value) {
                    applyValue({ ...item, value: 'N' });
                }
            }, [item, applyValue]);

            return (
                <FormControl fullWidth size="small" sx={{ mt: 0.4 }} variant="standard">
                    <InputLabel id="auto-match-filter-label">Value</InputLabel>
                    <Select
                        labelId="auto-match-filter-label"
                        value={item.value || ''}
                        onChange={(e) => applyValue({ ...item, value: e.target.value })}
                        label="Value"
                        displayEmpty={false}
                    >
                        <MenuItem value="Y">Yes</MenuItem>
                        <MenuItem value="N">No</MenuItem>
                    </Select>
                </FormControl>
            );
        },
    },
]);
const defaultCopyableStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block',
    width: '100%'
};

const rightAlignedCopyableStyle = {
    ...defaultCopyableStyle,
    textAlign: 'right'
};

const rightAlignedCellWrapperStyle = {
    width: '100%',
    textAlign: 'right'
};

const formatUtcDate = (value) => {
    if (!value) return '';
    return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC' }).format(new Date(value));
};

const getPeriodDaysValue = (value) => {
    if (value === null || value === undefined || value === '') return null;

    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : null;
    }

    const normalized = String(value).trim();
    if (!normalized) return null;

    if (normalized.includes(':')) {
        const parts = normalized.split(':');
        if (parts.length === 3) {
            const hours = Number(parts[0]);
            const minutes = Number(parts[1]);
            const seconds = Number(parts[2]);
            if (Number.isFinite(hours) && Number.isFinite(minutes) && Number.isFinite(seconds)) {
                return 0;
            }
        }
    }

    const numeric = Number(normalized);
    return Number.isFinite(numeric) ? numeric : null;
};

const formatPeriodDisplayValue = (value) => {
    if (value === null || value === undefined || value === '') return '';

    if (typeof value === 'number') {
        return value < 1 ? '' : `${value} Days`;
    }

    const normalized = String(value).trim();
    if (!normalized || normalized === '00:00:00') return '';

    if (normalized.includes(':')) {
        const parts = normalized.split(':');

        if (parts.length === 3) {
            const hours = Number(parts[0]);
            const minutes = Number(parts[1]);
            const seconds = Number(parts[2]);

            if (Number.isFinite(hours) && Number.isFinite(minutes) && Number.isFinite(seconds)) {
                const segments = [];
                if (hours > 0) segments.push(`${hours} hour${hours === 1 ? '' : 's'}`);
                if (minutes > 0) segments.push(`${minutes} minute${minutes === 1 ? '' : 's'}`);
                return segments.join(' ');
            }
        }
    }

    const numeric = Number(normalized);
    if (Number.isFinite(numeric)) {
        return numeric < 1 ? '' : `${numeric} Days`;
    }

    return '';
};

const renderCopyableCell = (displayValue, options = {}) => {
    const {
        copyValue = displayValue,
        tooltipTitle = displayValue,
        style = defaultCopyableStyle,
        tooltipPlacement = 'top-start'
    } = options;

    return (
        <CopyableCell
            value={copyValue ?? ''}
            tooltipTitle={tooltipTitle ?? ''}
            tooltipPlacement={tooltipPlacement}
            style={style}
        >
            {displayValue ?? ''}
        </CopyableCell>
    );
};

const renderWrappedHeader = (headerName, align = 'center') => (
    <div
        title={headerName}
        style={{
            width: '100%',
            whiteSpace: 'normal',
            lineHeight: 1.15,
            textAlign: align,
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            fontWeight: 500
        }}
    >
        {headerName}
    </div>
);

const AuditInvoicesReport = (props) => {
    // --- Initial Logic (previously in Constructor) ---
    const persisted = getFilter(['Reports', 'InvoiceAuditReport']) || {};
    const userInfo = JSON.parse(localStorage["userInfo"] || "{}");
    const authUserInfo = JSON.parse(localStorage.authenticatedUser || "{}");
    //const resourceId = userInfo?.id;
    const companyCode = userInfo?.companyCode || 0;

    const getDefaultModelDefId = (user) => {
        if (!stringIsNullOrEmpty(user.invoiceType)) {
            if (user.invoiceType.includes('1')) return 1;
            else if (user.invoiceType.includes('2')) return 2;
        }
        return 1;
    };

    const nineWeeksAgo = new Date();
    nineWeeksAgo.setDate(nineWeeksAgo.getDate() - 63);

    const defaultFilterModel = {
        items: [
            {
                field: 'invoiceDate',
                operator: 'after',
                value: nineWeeksAgo.toISOString().split('T')[0]
            },
        ]

    };

    const companiesList = authUserInfo?.authenticatedUserInfoList || [];
    const selectedCompaniesFromPersisted = persisted.selectedCompanies;
    let defaultCompaniesList = (selectedCompaniesFromPersisted || []).length > 0 ?
        companiesList?.filter(e => selectedCompaniesFromPersisted.indexOf(e.companyCode) > -1) :
        companiesList?.filter(e => e.companyCode === companyCode);

    // --- State ---
    //const [downloadingInvoices, setDownloadingInvoices] = useState({});
    const [data, setData] = useState([]);
    const [modelDefId, setModelDefId] = useState(persisted.modelDefId ?? getDefaultModelDefId(userInfo));
    const [filterText, setFilterTextState] = useState(persisted.filterText ?? '');
    const [columnVisibility, setColumnVisibility] = useState(persisted.columnVisibility || {});
    const [filterModel, setFilterModel] = useState(persisted.filterModel ?? defaultFilterModel);
    const [tempTableEnabled, setTempTableEnabled] = useState(false);
    const [exportData, setExportData] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    //const [filteredData, setFilteredData] = useState([]);
    const [hasSearched, setHasSearched] = useState(persisted.hasSearched ?? false);
    const [sortModel, setSortModel] = useState(persisted.sortModel || []);
    const [companyList, setCompanyList] = useState(companiesList);
    const [selectedCompanies, setSelectedCompanies] = useState(defaultCompaniesList);
    const [gridPageSize, setGridPageSize] = useState(10);
    //const [activeRowKey, setActiveRowKey] = useState(null);
    //const [activeInvoiceDocumentId, setActiveInvoiceDocumentId] = useState(null);
    //const [loadingRowIds, setLoadingRowIds] = useState([]);
    //const [openInvoiceDocumentEditorDialog, setOpenInvoiceDocumentEditorDialog] = useState(false);
    //const [mode, setMode] = useState(Constants?.VIEW || 'View');
    //const [rowData, setRowData] = useState(null);
    //const [creditMemoRowForRepost, setCreditMemoRowForRepost] = useState(null);
    //const [openCreditMemoRepostDialog, setOpenCreditMemoRepostDialog] = useState(false);
    //const [applyToInvoiceDocumentId, setApplyToInvoiceDocumentId] = useState(null);
    const [approvalLevels, setApprovalLevels] = useState([]); // New state for dynamic headers
    const [statusList, setStatusList] = useState({});
    const [activeRowKey, setActiveRowKey] = useState(null);
    const [activeInvoiceDocumentId, setActiveInvoiceDocumentId] = useState(null);
    const [openInvoiceDocumentEditorDialog, setOpenInvoiceDocumentEditorDialog] = useState(false);
    const [mode, setMode] = useState(Constants?.VIEW || 'View');
    const [rowData, setRowData] = useState(null);

    const mainGridRef = useRef(null);

    // --- Helpers ---
    //const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    //const resolveInvoiceStatusText = (row, sList) => {
    //    if (
    //        row?.invoicePostStatus?.toLowerCase() === 'partial posted' &&
    //        row?.postedNumberInvoice > 0 &&
    //        row?.postedNumberInvoice < row.totalNumberInvoice
    //    ) {
    //        return `Partially Posted (${row.postedNumberInvoice}/${row.totalNumberInvoice})`;
    //    }
    //    if (row?.invoiceDocumentStatusId === 170 && Number(row?.isCmInternalyPosted) === 1) {
    //        return 'Posted (Internally)';
    //    }
    //    return sList[row?.invoiceDocumentStatusId] ?? 'Unknown';
    //};

    const assignRowIds = (rows) => {
        let lastInvoiceId = null;
        let counter = 0;

        return rows.map(row => {
            if (row.invoiceNumber !== lastInvoiceId) {
                lastInvoiceId = row.invoiceNumber;
                counter = 1;
            } else {
                counter++;
            }

            return {
                ...row,
                rowId: `${row.invoiceNumber}_${counter}`
            };
        });
    };

    //const addLoadingRows = (rowIds = []) => {
    //    if (!rowIds || rowIds.length === 0) return;
    //    setLoadingRowIds(prev => Array.from(new Set([...prev, ...rowIds])));
    //};

    //const removeLoadingRows = (rowIds = []) => {
    //    if (!rowIds || rowIds.length === 0) return;
    //    setLoadingRowIds(prev => prev.filter(id => !rowIds.includes(id)));
    //};

    //const isRowLoading = (invoiceId) => (loadingRowIds || []).includes(invoiceId);

    //const isPostInProgressRow = (row) => {
    //    const postStatus = (row?.invoicePostStatus || '').toString().toLowerCase();
    //    const resolved = resolveInvoiceStatusText(row, statusList).toString().toLowerCase();
    //    return postStatus === 'post in progress' || resolved === 'post in progress';
    //};

    // --- Data Fetching ---
    const fetchInvoiceAudits = useCallback(({
        mDefId,
        fModel,
        sText,
        cList = [],
        isExport = false
    }) => {
        props.inProgress(true);

        httpPost('/api/reports/auditinvoices', {
            otherFilters: JSON.stringify(
                (fModel.items || [])
                    .map((f, idx) => ({
                        id: idx,
                        field: mapAuditFilterField(f.field),
                        operator: f.operator,
                        value: f.operator === 'isEmpty' || f.operator === 'isNotEmpty' ? true : normalizeAuditFilterValue(f.field, f.value)
                    }))
                    .filter(f => f.value !== undefined && f.value !== '')
            ),
            companies: cList.join(','),
            ModelDefId: mDefId,
        })
            .then((response) => {
                const {
                    rows = [],
                    approvalLevels: levels = [],
                    statusList: statuses = {}
                } = response.data || {};

                // Map clean, unique, fully static row keys that never recalculate on search filtering
                const rowsWithIds = rows.map((row, index) => ({
                    ...row,
                    rowId: row.invoiceDocumentId ? `${row.invoiceDocumentId}_${index}` : `row_${index}`
                }));
                const normalizedLevels = Array.isArray(levels) ? levels : [];

                setApprovalLevels(normalizedLevels);
                setStatusList(statuses);

                if (isExport) {
                    setExportData(rowsWithIds);
                    setDataLoaded(true);
                    setTempTableEnabled(true);
                } else {
                    setData(rowsWithIds);
                    mainGridRef.current?.setPage(0);
                }
                props.inProgress(false);
            })
            .catch((error) => {
                props.inProgress(false);
                if (isExport) setTempTableEnabled(false);
                toast.error('An error occurred while fetching the records');
                console.error(error);
            });
    }, [props]);

    // --- Secondary API Calls (COMMENTED OUT) ---

    //const fetchReportRowByInvoiceId = async (invoiceId, cCode) => {
    //    if (!invoiceId) return null;
    //    try {
    //        const response = await httpPost('/api/reports/vendorinvoices', {
    //            searchFilter: '',
    //            otherFilters: JSON.stringify([]),
    //            companies: (cCode ? String(cCode) : (selectedCompanies || []).map(e => e.companyCode).join(',')),
    //            logicOperator: 'and',
    //            ModelDefId: modelDefId,
    //            invoiceDocumentId: invoiceId,
    //            isAll: false
    //        });
    //        return response?.data?.rows || null;
    //    } catch (e) {
    //        return null;
    //    }
    //};

    //const refreshRowViaReportApi = async (invoiceId, cCode, options = {}, isCreditMemo = false, applyId = null) => {
    //    const manageLoading = options?.manageLoading !== false;
    //    if (manageLoading) addLoadingRows([invoiceId]);

    //    const oldRowData = data.find(r => r.invoiceDocumentId === invoiceId);
    //    const updatedRows = await fetchReportRowByInvoiceId(invoiceId, cCode);

    //    if (!updatedRows || updatedRows.length === 0) {
    //        if (manageLoading) removeLoadingRows([invoiceId]);
    //        fetchVendorInvoices({ mDefId: modelDefId, fModel: filterModel, sText: filterText, cList: selectedCompanies.map(e => e.companyCode) });
    //        return;
    //    }

    //    const newRowsWithIds = assignRowIds(updatedRows);

    //    setData(prev => {
    //        const firstIndex = prev.findIndex(r => r.invoiceDocumentId === invoiceId);
    //        const withoutInvoice = prev.filter(r => r.invoiceDocumentId !== invoiceId);
    //        const insertIndex = firstIndex === -1 ? withoutInvoice.length : firstIndex;
    //        return [...withoutInvoice.slice(0, insertIndex), ...newRowsWithIds, ...withoutInvoice.slice(insertIndex)]
    //    });

    //    setFilteredData(prev => {
    //        const firstIndex = prev.findIndex(r => r.invoiceDocumentId === invoiceId);
    //        const withoutInvoice = prev.filter(r => r.invoiceDocumentId !== invoiceId);
    //        const insertIndex = firstIndex === -1 ? withoutInvoice.length : firstIndex;
    //        return [...withoutInvoice.slice(0, insertIndex), ...newRowsWithIds, ...withoutInvoice.slice(insertIndex)]
    //    });

    //    if (manageLoading) removeLoadingRows([invoiceId]);

    //    if (isCreditMemo) {
    //        const updateRow = updatedRows[0];
    //        if (updateRow && applyId && Number(applyId) > 0 && updateRow.invoiceDocumentStatusId === 170 && oldRowData?.invoiceDocumentStatusId !== 180) {
    //            setOpenCreditMemoRepostDialog(true);
    //            setCreditMemoRowForRepost(updateRow);
    //            setApplyToInvoiceDocumentId(applyId);
    //        }
    //    }
    //};

  
    useEffect(() => {
        const gridRef = mainGridRef?.current;
        if (gridRef) {
            gridRef.setFilterModel({ ...filterModel, quickFilterValues: [''] });
            if (typeof gridRef.setQuickFilterValues === 'function') {
                gridRef.setQuickFilterValues([filterText]);
            }
        }

        fetchInvoiceAudits({
            mDefId: modelDefId,
            fModel: filterModel,
            cList: selectedCompanies.map(e => e.companyCode),
            sText: hasSearched ? filterText : ''
        });

        setFilter(['Reports', 'InvoiceAuditReport'], {
            ...getFilter(['Reports', 'InvoiceAuditReport']),
            hasSearched,
            filterText,
            modelDefId,
            filterModel,
            selectedCompanies: selectedCompanies.map(e => e.companyCode),
            columnVisibility
        });
    }, []); 

    const modelDefId_changeHandler = (event) => {
        const nextId = parseInt(event.target.value, 10);
        const stored = getFilter(['Reports', 'InvoiceAuditReport']) || {};
        const storedCodes = Array.isArray(stored.selectedCompanies) ? stored.selectedCompanies : [];
        const stateCodes = (selectedCompanies || []).map(c => c.companyCode);
        const finalCodes = storedCodes.length > 0 ? storedCodes : stateCodes;
        const nextSelected = companyList.filter(c => finalCodes.indexOf(c.companyCode) > -1);

        setData([]);
        setModelDefId(nextId);
        setSelectedCompanies(nextSelected);

        mainGridRef.current?.setFilterModel({ ...filterModel, quickFilterValues: [filterText || ''] });

        setFilter(['Reports', 'InvoiceAuditReport'], {
            ...stored,
            modelDefId: nextId,
            filterModel,
            filterText,
            columnVisibility,
            hasSearched,
        });

        fetchInvoiceAudits({
            mDefId: nextId,
            fModel: filterModel,
            cList: finalCodes,
            sText: hasSearched ? filterText : '',
        });
    };

    const handleFilterPanelSearch = (incomingFilterModel, quickFilterText = '') => {

        const updatedModel = {
            ...incomingFilterModel,
            items: [...(incomingFilterModel.items || [])]
        };
        setFilterModel(updatedModel);
        setFilterTextState(quickFilterText);
        setHasSearched(true);

        const codes = selectedCompanies.map(e => e.companyCode);
        setFilter(['Reports', 'InvoiceAuditReport'], {
            filterModel: updatedModel,
            filterText: quickFilterText,
            modelDefId,
            selectedCompanies: codes,
            columnVisibility,
            hasSearched: true,
        });

        fetchInvoiceAudits({
            mDefId: modelDefId,
            fModel: updatedModel,
            cList: codes,
            sText: quickFilterText
        });
    };


    //const removeRowFromGrid = (invoiceId) => {
    //    setData(prev => prev.filter(r => r.invoiceDocumentId !== invoiceId));
    //    setFilteredData(prev => prev.filter(r => r.invoiceDocumentId !== invoiceId));
    //    setLoadingRowIds(prev => prev.filter(id => id !== invoiceId));
    //    if (activeInvoiceDocumentId === invoiceId) {
    //        setActiveRowKey(null);
    //        setActiveInvoiceDocumentId(null);
    //    }
    //};

    //const insertInvoiceRowsAfterAnchor = async (newId, anchorId, cCode, attempts = 3, delayMs = 2000) => {
    //    if (!newId) return false;
    //    await delay(delayMs);

    //    let rows = null;
    //    for (let i = 0; i < attempts; i++) {
    //        rows = await fetchReportRowByInvoiceId(newId, cCode);
    //        if (rows && rows.length > 0) break;
    //        if (i < attempts - 1) await delay(delayMs);
    //    }

    //    if (!rows || rows.length === 0) {
    //        toast.warning(`Invoice created, but it is not available in the report yet.`);
    //        return false;
    //    }

    //    const newRowsWithIds = assignRowIds(rows);

    //    setData(prev => {
    //        const withoutNew = prev.filter(r => r.invoiceDocumentId !== newId);
    //        let insertIdx = withoutNew.length;
    //        if (anchorId) {
    //            const lastAnchor = withoutNew.map(r => r.invoiceDocumentId).lastIndexOf(anchorId);
    //            if (lastAnchor >= 0) insertIdx = lastAnchor + 1;
    //        }
    //        return [...withoutNew.slice(0, insertIdx), ...newRowsWithIds, ...withoutNew.slice(insertIdx)];
    //    });

    //    setFilteredData(prev => {
    //        const withoutNew = prev.filter(r => r.invoiceDocumentId !== newId);
    //        const lastAnchor = withoutNew.map(r => r.invoiceDocumentId).lastIndexOf(anchorId);
    //        if (lastAnchor >= 0) {
    //            return [...withoutNew.slice(0, lastAnchor + 1), ...newRowsWithIds, ...withoutNew.slice(lastAnchor + 1)];
    //        }
    //        return withoutNew;
    //    });
    //    return true;
    //};

    //const replaceInvoiceRowByFileKey = async (oldId, fileKey, cCode, attempts = 3, delayMs = 2000) => {
    //    if (!oldId || !fileKey) return;
    //    addLoadingRows([oldId]);

    //    try {
    //        await delay(delayMs);
    //        let newId = null;

    //        for (let i = 0; i < attempts; i++) {
    //            if (!newId) {
    //                const uri = `/api/invoicedocument/invoicedocumenteditorbyfilename/${encodeURIComponent(fileKey)}${cCode ? `?companyCode=${encodeURIComponent(cCode)}` : ''}`;
    //                const res = await httpGet(uri);
    //                newId = res?.data?.invoiceDocumentId || null;
    //            }

    //            if (newId) {
    //                const updatedRows = await fetchReportRowByInvoiceId(newId, cCode);
    //                if (updatedRows && updatedRows.length > 0) {
    //                    const newRowsWithIds = assignRowIds(updatedRows);
    //                    setData(prev => {
    //                        const firstIdx = prev.findIndex(r => r.invoiceDocumentId === oldId);
    //                        const withoutOld = prev.filter(r => r.invoiceDocumentId !== oldId);
    //                        const insertIdx = firstIdx >= 0 ? firstIdx : withoutOld.length;
    //                        return [...withoutOld.slice(0, insertIdx), ...newRowsWithIds, ...withoutOld.slice(insertIdx)];
    //                    });
    //                    setFilteredData(prev => {
    //                        const firstIdx = prev.findIndex(r => r.invoiceDocumentId === oldId);
    //                        const withoutOld = prev.filter(r => r.invoiceDocumentId !== oldId);
    //                        if (firstIdx >= 0) {
    //                            return [...withoutOld.slice(0, firstIdx), ...newRowsWithIds, ...withoutOld.slice(firstIdx)];
    //                        }
    //                        return withoutOld;
    //                    });
    //                    removeLoadingRows([oldId]);
    //                    return;
    //                }
    //            }
    //            if (i < attempts - 1) await delay(delayMs);
    //        }
    //        removeRowFromGrid(oldId);
    //        toast.warning('Replace is still in progress. New invoice will appear once available.');
    //    } finally {
    //        removeLoadingRows([oldId]);
    //    }
    //};

    //const invoiceDocumentEditor_closeHandler = ({
    //    wasUpdate = false,
    //    updatedRowFieldsData = null,
    //    responseObject = null,
    //    invoiceDocumentId = null,
    //    wasDelete = false,
    //    isCompanyChanged = false,
    //    isAvailableForRescaning = false,
    //    applyToInvoiceDocumentId: applyId = null
    //} = {}) => {
    //    const oldRow = rowData;
    //    const cCode = oldRow?.companyCode;
    //    const id = invoiceDocumentId || responseObject?.invoiceDocumentId || oldRow?.invoiceDocumentId;

    //    setOpenInvoiceDocumentEditorDialog(false);
    //    setRowData(null);

    //    if (isCompanyChanged && id) {
    //        removeRowFromGrid(id);
    //        return;
    //    }

    //    if (wasDelete && id) {
    //        removeRowFromGrid(id);
    //        return;
    //    }

    //    if (responseObject?.operation === 'creditMemo' && invoiceDocumentId) {
    //        const sourceId = oldRow?.invoiceDocumentId || null;
    //        if (sourceId) addLoadingRows([sourceId]);
    //        (async () => {
    //            try {
    //                if (sourceId) await refreshRowViaReportApi(sourceId, cCode, { manageLoading: false });
    //                await insertInvoiceRowsAfterAnchor(invoiceDocumentId, sourceId, cCode);
    //            } finally {
    //                if (sourceId) removeLoadingRows([sourceId]);
    //            }
    //        })();
    //        return;
    //    }

    //    if (responseObject?.openLinkedInvoice === true && responseObject?.invoiceDocumentId) {
    //        const isCM = responseObject.invoiceIndicator === 2;
    //        setOpenInvoiceDocumentEditorDialog(true);
    //        setMode(isCM ? Constants.CREDIT_MEMO : Constants.VIEW);
    //        setRowData({ invoiceDocumentId: responseObject.invoiceDocumentId });
    //        setActiveRowKey(null);
    //        setActiveInvoiceDocumentId(responseObject.invoiceDocumentId);
    //        return;
    //    }

    //    if (responseObject?.operation === 'replace' && id) {
    //        const fileKey = responseObject.invoiceDocumentFileLocation || responseObject.fileName;
    //        if (fileKey) replaceInvoiceRowByFileKey(id, fileKey, cCode);
    //        return;
    //    }

    //    if ((wasUpdate || !!updatedRowFieldsData) && id) {
    //        if (isAvailableForRescaning) props.inProgress(true);
    //        refreshRowViaReportApi(id, cCode, {}, isAvailableForRescaning, applyId)
    //            .finally(() => props.inProgress(false));
    //    }
    //};

    // --- Column Definitions ---


    const columns = useMemo(() => {
        let cols = [
            {
                headerName: 'Company',
                field: 'companyName',
                width: 100,
                minWidth: 80,
                maxWidth: 180,
                filterable: false,
                renderCell: (params) => renderCopyableCell(params.value)
            },
            {
                headerName: 'Vendor Code',
                field: 'vendorCode',
                width: 115,
                minWidth: 100,
                maxWidth: 150,
                renderCell: (params) => renderCopyableCell(params.value)
            },
            {
                headerName: 'Vendor Name',
                field: 'vendorName',
                width: 140,
                minWidth: 130,
                maxWidth: 260,
                renderCell: (params) => renderCopyableCell(params.value)
            },
            {
                headerName: 'Invoice Number',
                field: 'invoiceNumber',
                width: 160,
                minWidth: 140,
                maxWidth: 220,
                renderCell: (params) => renderCopyableCell(params.value)
            },
            {
                headerName: 'Status',
                field: 'invoiceStatus',
                type: 'singleSelect',
                valueOptions: Object.entries(statusList || {}).map(([, label]) => ({
                    value: label,
                    label
                })),
                width: 140,
                minWidth: 100,
                maxWidth: 240,
                renderCell: (params) => renderCopyableCell(params.value)
            },
            {
                headerName: 'Upload Date',
                renderHeader: () => renderWrappedHeader('Upload Date'),
                field: 'invoiceDate',
                width: 110,
                minWidth: 100,
                maxWidth: 130,
                type: 'date',
                valueGetter: ({ value }) => value || '',
                valueFormatter: ({ value }) => formatUtcDate(value),
                renderCell: (params) => renderCopyableCell(params.formattedValue || formatUtcDate(params.value))
            },
            {
                headerName: 'Upload By',
                renderHeader: () => renderWrappedHeader('Upload By'),
                field: 'postedUserName',
                width: 160,
                minWidth: 140,
                maxWidth: 220,
                renderCell: (params) => renderCopyableCell(params.value)
            },
            {
                headerName: 'Auto-Match',
                renderHeader: () => renderWrappedHeader('Auto-Match', 'center'),
                field: 'isAutoMatch',
                type: 'singleSelect',
                valueOptions: [
                    { value: 'Y', label: 'Yes' },
                    { value: 'N', label: 'No' },
                ],
                filterOperators: getAutoMatchFilterOperators(),
                width: 95,
                minWidth: 90,
                maxWidth: 105,
                align: 'center',
                headerAlign: 'center',
                valueGetter: (params) => Number(params.row?.isAutoMatch) === 1 ? 'Y' : 'N',
                valueFormatter: ({ value }) => value === 'Y' ? 'Yes' : 'No',
                renderCell: (p) => Number(p.row?.isAutoMatch) === 1 ? <Check color="action" /> : <RemoveIcon color="action" />
            },
            {
                headerName: 'Period in Discrepancy State',
                renderHeader: () => renderWrappedHeader('Period in Discrepancy State', 'right'),
                field: 'discrepancyPeriod',
                width: 170,
                minWidth: 160,
                maxWidth: 220,
                type: 'number',
                align: 'right',
                headerAlign: 'right',
                valueGetter: ({ value }) => getPeriodDaysValue(value),
                 valueFormatter: (params) => formatPeriodDisplayValue(params.api?.getRow(params.id)?.[params.field] ?? params.value),
                renderCell: (params) => (
                    <div style={rightAlignedCellWrapperStyle}>
                        {renderCopyableCell(formatPeriodDisplayValue(params.row?.discrepancyPeriod), { style: rightAlignedCopyableStyle })}
                    </div>
                )
            },
        ];

        // --- START DYNAMIC APPROVAL LEVELS ---

        const routingCount = Math.max(
            0,
            ...(approvalLevels || []).map(level => Number(level?.routingNumberOfApprovalLevels || 0))
        );

        const getLevelHeader = (levelNumber) => {
            const levelKey = `approvalLevel${levelNumber}StatusName`;
            const levelInfo = (approvalLevels || []).find(level => !stringIsNullOrEmpty(level?.[levelKey]));
            return levelInfo?.[levelKey] || 'Approval';
        };

        const levelConfigs = [
            {
                isActive: routingCount >= 1,
                label: getLevelHeader(1),
                dateField: 'approvalLevel1Date',
                byField: 'approvalLevel1By',
                periodField: 'approvalLevel1WaitingDays'
            },
            {
                isActive: routingCount >= 2,
                label: getLevelHeader(2),
                dateField: 'approvalLevel2Date',
                byField: 'approvalLevel2By',
                periodField: 'approvalLevel2WaitingDays'
            },
            {
                isActive: routingCount >= 3,
                label: getLevelHeader(3),
                dateField: 'approvalLevel3Date',
                byField: 'approvalLevel3By',
                periodField: 'approvalLevel3WaitingDays'
            },
            {
                isActive: routingCount >= 4,
                label: getLevelHeader(4),
                dateField: 'approvalLevel4Date',
                byField: 'approvalLevel4By',
                periodField: 'approvalLevel4WaitingDays'
            },
            {
                isActive: routingCount >= 5,
                label: getLevelHeader(5),
                dateField: 'approvalLevel5Date',
                byField: 'approvalLevel5By',
                periodField: 'approvalLevel5WaitingDays'
            }
        ];

        levelConfigs.filter(level => level.isActive).forEach(level => {
            cols.push(
                {
                    headerName: `${level.label} Approved Date`,
                    renderHeader: () => renderWrappedHeader(`${level.label} Approved Date`),
                    field: level.dateField,
                    width: 110,
                    minWidth: 100,
                    maxWidth: 130,
                    type: 'date',
                    valueGetter: ({ value }) => value || '',
                    valueFormatter: ({ value }) => formatUtcDate(value),
                    renderCell: (params) => renderCopyableCell(params.formattedValue || formatUtcDate(params.value))
                },
                {
                    headerName: `${level.label} Approved By`,
                    renderHeader: () => renderWrappedHeader(`${level.label} Approved By`),
                    field: level.byField,
                    width: 150,
                    minWidth: 130,
                    maxWidth: 220,
                    renderCell: (params) => renderCopyableCell(params.value)
                },
                {
                    headerName: `Period in ${level.label} State`,
                    renderHeader: () => renderWrappedHeader(`Period in ${level.label} State`, 'right'),
                    field: level.periodField,
                    width: 170,
                    minWidth: 160,
                    maxWidth: 220,
                    type: 'number',
                    align: 'right',
                    headerAlign: 'right',
                    valueGetter: ({ value }) => getPeriodDaysValue(value),
                     valueFormatter: (params) => formatPeriodDisplayValue(params.api?.getRow(params.id)?.[params.field] ?? params.value),
                    renderCell: (params) => (
                        <div style={rightAlignedCellWrapperStyle}>
                            {renderCopyableCell(formatPeriodDisplayValue(params.row?.[level.periodField]), { style: rightAlignedCopyableStyle })}
                        </div>
                    )
                }
            );
        });
        // --- END DYNAMIC APPROVAL LEVELS ---

        cols.push(
            {
                headerName: 'Payment Days',
                renderHeader: () => renderWrappedHeader('Payment Days', 'right'),
                field: 'paymentDays',
                width: 80,
                minWidth: 75,
                maxWidth: 95,
                type: 'number',
                align: 'right',
                headerAlign: 'right',
                valueGetter: ({ value }) => value === null || value === undefined || value === '' ? null : Number(value),
                renderCell: (params) => (
                    <div style={rightAlignedCellWrapperStyle}>
                        {renderCopyableCell(params.value, { style: rightAlignedCopyableStyle })}
                    </div>
                )
            },
            {
                headerName: 'Payment Date',
                renderHeader: () => renderWrappedHeader('Payment Date'),
                field: 'paymentDate',
                width: 110,
                minWidth: 100,
                maxWidth: 130,
                type: 'date',
                valueGetter: ({ value }) => value || '',
                valueFormatter: ({ value }) => formatUtcDate(value),
                renderCell: (params) => renderCopyableCell(params.formattedValue || formatUtcDate(params.value))
            }
        );

        return cols;
    }, [approvalLevels, statusList]);


    const filteredRows = useMemo(() => {
        const q = (filterText || '').trim().toLowerCase();
        if (!q) return data;
        return data.filter(row => {
            return Object.keys(row).some(key => {
                if (key === 'rowId') return false;
                return String(row[key] || '').toLowerCase().includes(q);
            });
        });
    }, [data, filterText]);

    useEffect(() => {
        mainGridRef.current?.setPage(0);
    }, [filterText]);

    useEffect(() => {
        mainGridRef.current?.setPage(0);
    }, [gridPageSize]);

    const getInvoiceTypeMenuItem = (id, display) => {
        if (userInfo.invoiceType?.includes('' + id)) {
            return <MenuItem value={id}>{display}</MenuItem>;
        }
        return null;
    };

    const detail_clickHandler = (row) => {
        setOpenInvoiceDocumentEditorDialog(true);
        setMode(Constants?.VIEW || 'View');
        setRowData(row);
        setActiveRowKey(row?.rowId ?? null);
        setActiveInvoiceDocumentId(row?.invoiceDocumentId ?? null);
    };

    const invoiceDocumentEditor_closeHandler = ({
        wasUpdate = false,
        wasDelete = false,
        isCompanyChanged = false
    } = {}) => {
        setOpenInvoiceDocumentEditorDialog(false);
        setRowData(null);

        if (wasUpdate || wasDelete || isCompanyChanged) {
            fetchInvoiceAudits({
                mDefId: modelDefId,
                fModel: filterModel,
                cList: selectedCompanies.map(e => e.companyCode),
                sText: hasSearched ? filterText : ''
            });
        }
    };

    const editorInfo = {
        rowData,
        invoiceDocumentId: rowData?.invoiceDocumentId,
        mode,
        source: rowData?.invoiceSource,
        inProgress: props.inProgress,
        modelDefId,
        editorSource: Constants.SOURCE_AUDIT_REPORT,
        companyCode: rowData?.companyCode
    };

    return (
        <div>
            <h1>Audit Log Invoices</h1>
            <style>{`
                .vendor-report-active-invoice { background-color: rgba(0, 140, 205, 0.15); }
                .vendor-report-active-invoice:hover { background-color: rgba(0, 140, 205, 0.22); }
                .vendor-report-refetching-row { 
                    opacity: 0.55;
                    cursor: not-allowed;
                    filter: grayscale(0.25);
                    background-color: rgba(0,0,0,0.03);
                }
            `}</style>
            <div className="form-group">
                <div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
                    <EnhancedDataGrid
                        rows={filteredRows} // 1. Pass the client-side filtered rows array here
                        rowHeight={51}
                        columnHeaderHeight={64}
                        disableColumnMenu
                        pagination
                        pageSize={10}
                        columns={columns}
                        options={{
                            pageSize: 10,
                            pageSizeOptions: [10, 20, 30, 40, 50],
                            maxBodyHeight: 670,
                            filtering: true,
                            columnsButton: true,
                            exportButton: true,
                            exportAllData: true,
                            exportFileName: "invoiceAudit"
                        }}
                        filterMode="client" // 2. Switch this to client mode so local rows match page items properly
                        gridRef={mainGridRef}
                        highlightSearchTextOnMainScreenGrid={true}
                        showSearchButtonInToolbar={true}
                        customFilterPanel={true}
                        customcomponent={
                            <>
                                <StyledMultiSelect
                                    items={companyList}
                                    defaultItems={[companyCode]}
                                    selectedItems={selectedCompanies.map(e => e.companyCode) || [companyCode]}
                                    callback={(values) => {
                                        setFilter(['Reports', 'InvoiceAuditReport'], {
                                            ...getFilter(['Reports', 'InvoiceAuditReport']),
                                            selectedCompanies: values
                                        });
                                        setSelectedCompanies(companyList.filter(e => values.indexOf(e.companyCode) > -1));
                                    }}
                                    onCloseCallback={() => {
                                        fetchInvoiceAudits({
                                            mDefId: modelDefId,
                                            fModel: filterModel,
                                            sText: filterText,
                                            cList: selectedCompanies.map(e => e.companyCode)
                                        });
                                    }}
                                />
                                <Select
                                    variant='standard'
                                    style={{ float: "right", marginTop: 2, marginRight: 10 }}
                                    value={modelDefId}
                                    onChange={modelDefId_changeHandler}
                                    sx={{ backgroundColor: "rgba(0, 140, 205, 0.25)" }}
                                >
                                    {getInvoiceTypeMenuItem(1, 'Media')}
                                    {getInvoiceTypeMenuItem(2, 'Production')}
                                    {getInvoiceTypeMenuItem(3, 'Broadcast')}
                                </Select>
                            </>
                        }
                        getRowId={(row) => row.rowId}
                        getRowClassName={(params) => {
                            const classes = [];
                            if (activeRowKey !== null && params.row?.rowId === activeRowKey) {
                                classes.push('vendor-report-active-invoice');
                            }
                            return classes.join(' ');
                        }}
                        onRowClick={(params, event) => {
                            const row = params?.row;
                            if (!row) return;

                            const target = event?.target;
                            const clickedInteractive =
                                target?.closest && (
                                    target.closest('a') ||
                                    target.closest('button') ||
                                    target.closest('input') ||
                                    target.closest('.MuiCheckbox-root') ||
                                    target.closest('.MuiDataGrid-checkboxInput')
                                );

                            if (clickedInteractive) return;

                            setActiveRowKey(row?.rowId ?? null);
                            setActiveInvoiceDocumentId(row?.invoiceDocumentId ?? null);
                            detail_clickHandler(row);
                        }}
                        onFilterPanelSearch={(incomingFilterModel, quickFilterText) => {
                            handleFilterPanelSearch(incomingFilterModel, quickFilterText);
                        }}
                        searchCallback={(text) => {
                            setFilterTextState(text || '');
                        }}
                        setFilterText={(text) => {
                            const trimmed = text?.trim() || '';
                            const stored = getFilter(['Reports', 'InvoiceAuditReport']) || {};
                            if (trimmed === stored.filterText) return;

                            const shouldReset = stored.hasSearched && stored.filterText !== trimmed;
                            const nextSearch = shouldReset ? false : stored.hasSearched;

                            setFilterTextState(trimmed);
                            setHasSearched(nextSearch);
                            setFilter(['Reports', 'InvoiceAuditReport'], { ...stored, filterText: trimmed, hasSearched: nextSearch });
                        }}
                        columnVisibilityModel={columnVisibility}
                        onColumnVisbilityModelChange={(model) => {
                            setColumnVisibility(model);
                            setFilter(['Reports', 'InvoiceAuditReport'], { ...getFilter(['Reports', 'InvoiceAuditReport']), columnVisibility: model });
                        }}
                        sortModel={sortModel}
                        onSortModelChange={(model) => {
                            setSortModel(model);
                            setFilter(['Reports', 'InvoiceAuditReport', 'sortModel'], model);
                        }}
                        exportServerCallback={() => {
                            setTempTableEnabled(true);
                            fetchInvoiceAudits({
                                mDefId: modelDefId,
                                fModel: filterModel,
                                sText: filterText,
                                cList: selectedCompanies.map(e => e.companyCode),
                                isExport: true
                            });
                        }}
                        onPaginationModelChange={(model) => {
                            if (model?.pageSize !== undefined && model.pageSize !== gridPageSize) {
                                setGridPageSize(model.pageSize);
                            }
                        }}
                    />
                </div>

                {tempTableEnabled && (
                    <ServerExportWrapper
                        rows={exportData}
                        initialState={{ columns: { columnVisibilityModel: mainGridRef.current.exportState().columns.columnVisibilityModel } }}
                        columns={columns}
                        options={{ exportFileName: "VendorInvoices" }}
                        dataLoaded={dataLoaded}
                        getRowId={(row) => row.rowId}
                        resetStates={() => {
                            setTempTableEnabled(false);
                            setDataLoaded(false);
                            setExportData([]);
                        }}
                    />
                )}

                {openInvoiceDocumentEditorDialog && (
                    <Dialog open={openInvoiceDocumentEditorDialog} fullScreen>
                        <InvoiceDocumentEditor
                            info={editorInfo}
                            clientInfo={{ rowData, mode, modelDefId, inProgress: props.inProgress }}
                            onClose={invoiceDocumentEditor_closeHandler}
                            fetchDashboard={() => { }}
                        />
                    </Dialog>
                )}

                {/*{openInvoiceDocumentEditorDialog && (*/}
                {/*    <Dialog open={openInvoiceDocumentEditorDialog} TransitionComponent={Transition} fullScreen>*/}
                {/*        <InvoiceDocumentEditor*/}
                {/*            info={editorInfo}*/}
                {/*            clientInfo={{ rowData, mode, modelDefId, inProgress: props.inProgress }}*/}
                {/*            onClose={invoiceDocumentEditor_closeHandler}*/}
                {/*            fetchDashboard={() => { }}*/}
                {/*        />*/}
                {/*    </Dialog>*/}
                {/*)}*/}

                {/*<Dialog open={openCreditMemoRepostDialog} TransitionComponent={Transition}>*/}
                {/*    <DialogTitle>Post Credit Memo</DialogTitle>*/}
                {/*    <DialogContent><DialogContentText>Do you want to rescan the original invoice as well?</DialogContentText></DialogContent>*/}
                {/*    <DialogActions>*/}
                {/*        <Button onClick={async () => {*/}
                {/*            if (!applyToInvoiceDocumentId) return;*/}
                {/*            props.inProgress(true);*/}
                {/*            try {*/}
                {/*                await httpPost("/api/invoicedocument/rescanoriginalinvoice", {*/}
                {/*                    companyCode: companyCode,*/}
                {/*                    modelDefId: modelDefId,*/}
                {/*                    applyToInvoiceDocumentId: applyToInvoiceDocumentId*/}
                {/*                });*/}
                {/*                toast.success('Invoice sent for rescan');*/}
                {/*                setOpenCreditMemoRepostDialog(false);*/}
                {/*            } catch { toast.error('Rescanning failed'); }*/}
                {/*            props.inProgress(false);*/}
                {/*        }}>Yes</Button>*/}
                {/*        <Button onClick={() => setOpenCreditMemoRepostDialog(false)}>Cancel</Button>*/}
                {/*    </DialogActions>*/}
                {/*</Dialog>*/}
            </div>
        </div>
    );
};

// --- Helper Child Component ---
const StyledMultiSelect = ({ items = [], selectedItems = [], defaultItems = [], callback, onCloseCallback }) => {
    const [initialValues, setInitialValues] = useState([]);

    const menuItemOnChange = (event) => {
        let values = typeof event.target.value === "string" ? event.target.value.split(",") : event.target.value;
        if ((values || []).filter(e => e).length === 0) values = defaultItems;
        callback(values);
    };

    const arrayEqual = (arr1, arr2) => {
        if (arr1.length !== arr2.length) return false;
        return arr1.every(e => arr2.indexOf(e) > -1) && arr2.every(e => arr1.indexOf(e) > -1);
    };

    return (
        <Select
            multiple variant="standard" value={selectedItems} onChange={menuItemOnChange}
            onOpen={() => setInitialValues(selectedItems)}
            onClose={() => { if (!arrayEqual(selectedItems, initialValues)) { onCloseCallback(); setInitialValues([]); } }}
            displayEmpty
            style={{ float: "right", marginTop: 2, marginRight: 10 }}
            sx={{ backgroundColor: "rgba(0, 140, 205, 0.25)", minWidth: 180 }}
            renderValue={(selected) => {
                if (selected.length === 0) return "Select Company";
                if (selected.length === 1) {
                    const item = items.find((i) => i.companyCode === selected[0]);
                    return item ? item.coName : "Select Company";
                }
                const names = items.filter(e => selected.indexOf(e.companyCode) > -1).map(e => e.coName).join(", ");
                return names.length > 20 ? names.substring(0, 18).concat('...') : names;
            }}
        >
            {items.map((item) => (
                <MenuItem key={item.companyCode} value={item.companyCode}>
                    <Checkbox checked={selectedItems.indexOf(item.companyCode) > -1} />
                    <ListItemText primary={defaultItems.indexOf(item.companyCode) > -1 ? `${item.coName}(default)` : item.coName} />
                </MenuItem>
            ))}
        </Select>
    );
};

export default AuditInvoicesReport;